export class DeleteUnusedUsers {
  static readonly type = '[Auth] Delete Users';
  constructor(public uid: string) {}
}
